module.exports = __webpack_public_path__ + "img/logo-vertical-new.e3f35166.svg";